// src/services/projectService.js
let projectCache = null;
let fetchPromise = null;

/**
 * Fetches the project list from the API and caches it.
 * If a fetch is already in progress, it returns the same promise.
 * If data is already cached, it returns the cached data.
 */
export const getProjects = async (forceRefresh = false) => {
    if (projectCache && !forceRefresh) {
        return projectCache;
    }

    if (fetchPromise && !forceRefresh) {
        return fetchPromise;
    }

    fetchPromise = (async () => {
        try {
            const res = await fetch("/api/getProjectList");
            if (!res.ok) throw new Error("Failed to fetch projects");
            const data = await res.json();
            projectCache = data.projects || [];
            return projectCache;
        } catch (err) {
            console.error("Project service error:", err);
            throw err;
        } finally {
            fetchPromise = null;
        }
    })();

    return fetchPromise;
};

export const clearProjectCache = () => {
    projectCache = null;
};
